import { render, staticRenderFns } from "./ChannelLesson.vue?vue&type=template&id=0eb2cf67&scoped=true"
import script from "./ChannelLesson.vue?vue&type=script&lang=js"
export * from "./ChannelLesson.vue?vue&type=script&lang=js"
import style0 from "./ChannelLesson.vue?vue&type=style&index=0&id=0eb2cf67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb2cf67",
  null
  
)

export default component.exports